export const getIds = array => {
	if (!Array.isArray(array) || array.length === 0 || array?.[0]?.Id === undefined) return [];

	return array.map(i => parseInt(i.Id));
};